// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-upper-case[data-v-c9191872]{padding:2px 5px;border-radius:3px}.text-normal-case[data-v-c9191872],.text-upper-case[data-v-c9191872]{display:inline-block;font-size:11px;line-height:12px;font-weight:500}.text-normal-case[data-v-c9191872]{padding:1px 4px;border:1px solid #888;border-radius:3px}", ""]);
// Exports
module.exports = exports;
